export default __webpack_public_path__ + "static/media/filter-search-icon.9576cdd5.svg";